import * as React from 'react';
import * as ReactDOM from 'react-dom';
import './Content/CSS/index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
ReactDOM.render(React.createElement(App, null), document.querySelector('#root'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
